import { filter, find, map, isEmpty } from 'lodash';

import { loadXMLFromURL } from './load-xml-from-url';

/**
 * Fetches the names of the layers, styles and tile matrix sets for a WMTS variables stored in the URL.
 *
 * @async
 * @param {string} url - The URL where the WMTS is stored.
 * @param {string} targetLayerId - The id of the layer selected by the user. Empty if none selected.
 * @returns {object} The WMTS layers, styles, Tile matrix and format values.
 * @throws {Error} If something goes wrong.
 */
const getWMTSParamsFromURL = async (url, targetLayerId) => {
  try {
    const xmlText = await loadXMLFromURL(url, 'wmts');
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
    const layers = xmlDoc.getElementsByTagName('Layer');

    let tileMatrixSetOptions = [];
    let styleOptions = [];
    let formatOptions = [];

    const layerOptions = filter(
      map(layers, layer => layer.getElementsByTagName('ows:Identifier')[0].textContent.trim()),
      layerId => !isEmpty(layerId)
    );
    if (!isEmpty(targetLayerId)) {
      const targetLayer = find(
        layers,
        layer =>
          targetLayerId === layer.getElementsByTagName('ows:Identifier')[0].textContent.trim()
      );

      const layerStyles = targetLayer.getElementsByTagName('Style');
      styleOptions = map(layerStyles, layerStyle =>
        layerStyle.getElementsByTagName('ows:Identifier')[0].textContent.trim()
      );

      const layerFormats = targetLayer.getElementsByTagName('Format');
      formatOptions = map(layerFormats, layerFormat => layerFormat.textContent.trim());

      const layerTileMatrixSets = targetLayer.getElementsByTagName('TileMatrixSetLink');
      tileMatrixSetOptions = map(layerTileMatrixSets, layerTileMatrix =>
        layerTileMatrix.getElementsByTagName('TileMatrixSet')[0].textContent.trim()
      );
    }

    return {
      layerOptions: layerOptions.join(','),
      tileMatrixSetOptions: tileMatrixSetOptions.join(','),
      styleOptions: styleOptions.join(','),
      formatOptions: formatOptions.join(',')
    };
  } catch (error) {
    throw new Error(error.message);
  }
};

export default getWMTSParamsFromURL;
